module.exports = __webpack_public_path__ + "static/media/logo-pioxii.8426d86d.png";